import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import Accordion from '../Accordion/Accordion';

class BOTManagementLists extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showInactiveCustomers: false,
            showInactiveInternal: false
        }
    }

    checkPermission = (permission) => {
        this.props.info('BOTManagementLists.js/checkPermission (permission)', permission);
        const permissionGranted =
            permission === '' || permission == null ||
            this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    render() {
        this.props.info('BOTManagementLists.js/render');
        const botRequestTicketsCustomer = this.props.botRequestTicketsCustomer;//.filter(bot => (this.state.showInactiveCustomers || (!this.state.showInactiveCustomers && bot.technologyStatus !== 2)));
        const botRequestTicketsInternal = this.props.botRequestTicketsInternal;//.filter(bot => (this.state.showInactiveInternal || (!this.state.showInactiveInternal && bot.technologyStatus !== 2)));
        const botRequestTicketsRejected = this.props.botRequestTicketsRejected;
        const botApplicationTypes = [...this.props.applicationTypes].concat({key: null, value: 'No Application Type'});
        return (
            <Row className='mb-3'>
                <Col md={4}>
                    <Row>
                        <Col md={4}></Col>
                        <Col md={4} className='text-center'>
                            <h4>Customer</h4>
                        </Col>
                        {/* <Col md={4}>
                            <Form inline>
                                <FormGroup className='mt-1 mr-2 text-right'>
                                    <Label for={"showInactiveCustomers"}>
                                        Show Inactive
                                    </Label>
                                    <Input
                                        type="checkbox"
                                        id="showInactiveCustomers"
                                        className='ml-2'
                                        checked={this.state.showInactiveCustomers}
                                        onChange={e => this.setState({ showInactiveCustomers: !this.state.showInactiveCustomers })} />
                                </FormGroup>
                            </Form>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col>
                            {botRequestTicketsCustomer.length > 0 &&
                                <Accordion data={[...new Set([...botRequestTicketsCustomer.map(bot => bot.clientName)])].sort().map(row => (
                                    {
                                        title: `${row}`,
                                        subinfo: `(${botRequestTicketsCustomer.filter(bot => bot.clientName === row).length})`,
                                        data: botRequestTicketsCustomer.filter(bot => bot.clientName === row),
                                        component: (data) => data.map((row, rowIndex) =>
                                            <div
                                                key={rowIndex}
                                                onClick={() => this.props.onEdit(row.id, true)}
                                                className={"pointer" + (rowIndex < data.length - 1 ? " mb-2 pb-2 border-bottom border-secondary" : "")}
                                            >
                                                <div><span className='font-weight-bold'>{row.requestId !== 4 ? row.requestCategory : row.requestOther}</span>
                                                    &nbsp;({[...this.props.priorities].filter(priority => priority.key === row.priorityId).shift().value}
                                                    {row.technologyStatus === 2 ? ', Inactive' : ''}
                                                    )</div>
                                                <div>Requestor: {row.lastName}, {row.firstName}</div>
                                                <div>Team: {row.teamName}</div>
                                                {row.assignedLastName != null && <div>Assigned: {row.assignedLastName}{row.assignedLastName != null ? `, ${row.assignedFirstName}` : ''}</div>}
                                                {row.applicationName != null && <div>Application: {row.applicationName} {row.version != null && row.version !== '' ? `(v${row.version})` : ''}</div>}
                                            </div>
                                        )
                                    }
                                ))} />}
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Row>
                        <Col md={4}></Col>
                        <Col md={4} className='text-center'>
                            <h4>Internal</h4>
                        </Col>
                        {/* <Col md={4}>
                            <Form inline>
                                <FormGroup className='mt-1 mr-2 text-right'>
                                    <Label for={"showInactiveInternal"}>
                                        Show Inactive
                                    </Label>
                                    <Input
                                        type="checkbox"
                                        id="showInactiveInternal"
                                        className='ml-2'
                                        checked={this.state.showInactiveInternal}
                                        onChange={e => this.setState({ showInactiveInternal: !this.state.showInactiveInternal })} />
                                </FormGroup>
                            </Form>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col>
                            {botRequestTicketsInternal.length > 0 &&
                                <Accordion data={[...new Set(
                                    [...botRequestTicketsInternal
                                        // .filter(bot => bot.applicationType != null)
                                        .map(bot => botApplicationTypes.filter(type => type.key === bot.applicationType)[0].value)
                                    ])]
                                    .sort()
                                    .map(row => (
                                        {
                                            title: `${row}`,
                                            subinfo: `(${botRequestTicketsInternal.filter(bot => /*bot.applicationType != null &&*/ botApplicationTypes.filter(type => type.key === bot.applicationType)[0].value === row).length})`,
                                            data: botRequestTicketsInternal.filter(bot => /*bot.applicationType != null &&*/ botApplicationTypes.filter(type => type.key === bot.applicationType)[0].value === row),
                                            component: (data) => data.map((row, rowIndex) =>
                                                <div
                                                    key={rowIndex}
                                                    onClick={() => this.props.onEdit(row.id, true)}
                                                    className={"pointer" + (rowIndex < data.length - 1 ? " mb-2 pb-2 border-bottom border-secondary" : "")}
                                                >
                                                    <div>
                                                        <span className='font-weight-bold'>{row.clientName}</span>
                                                        {/* &nbsp;({[...this.props.priorities].filter(priority => priority.key === row.priorityId).shift().value}
                                                    {row.technologyStatus === 2 ? ', Inactive' : ''}) */}
                                                    </div>
                                                    <div>Requestor: {row.lastName}, {row.firstName}</div>
                                                    <div>Team: {row.teamName}</div>
                                                    {row.assignedLastName != null && <div>Assigned: {row.assignedLastName}{row.assignedLastName != null ? `, ${row.assignedFirstName}` : ''}</div>}
                                                    {row.applicationName != null && <div>Application: {row.applicationName} {row.version != null && row.version !== '' ? `(v${row.version})` : ''}</div>}
                                                    <div>Clients Using: {row.clientsUsing != null ? JSON.parse(row.clientsUsing).length : 0}</div>
                                                </div>
                                            )
                                        }
                                    ))} />}
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Row>
                        <Col className='text-center'>
                            <h4>Rejected</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {botRequestTicketsRejected.length > 0 &&
                                <Accordion data={[...new Set(
                                    [...botRequestTicketsRejected
                                        // .filter(bot => )
                                        .map(bot => bot.applicationType != null ? botApplicationTypes.filter(type => type.key === bot.applicationType)[0].value : 'No Application Type')
                                    ])]
                                    .sort()
                                    .map(row => (
                                        {
                                            title: `${row}`,
                                            subinfo: `(${botRequestTicketsRejected.length})`,
                                            data: botRequestTicketsRejected.filter(bot => bot.applicationType != null ? botApplicationTypes.filter(type => type.key === bot.applicationType)[0].value === row : bot.applicationType == null),
                                            component: (data) => data.map((row, rowIndex) =>
                                                <div
                                                    key={rowIndex}
                                                    onClick={() => this.props.onEdit(row.id, true)}
                                                    className={"pointer" + (rowIndex < data.length - 1 ? " mb-2 pb-2 border-bottom border-secondary" : "")}
                                                >
                                                    <div>
                                                        <span className='font-weight-bold'>{row.clientName}</span>
                                                    </div>
                                                    <div>Requestor: {row.lastName}, {row.firstName}</div>
                                                    <div>Team: {row.teamName}</div>
                                                    {row.assignedLastName != null && <div>Assigned: {row.assignedLastName}{row.assignedLastName != null ? `, ${row.assignedFirstName}` : ''}</div>}
                                                    {row.applicationName != null && <div>Application: {row.applicationName} {row.version != null && row.version !== '' ? `(v${row.version})` : ''}</div>}
                                                    <div>Clients Using: {row.clientsUsing != null ? JSON.parse(row.clientsUsing).length : 0}</div>
                                                </div>
                                            )
                                        }
                                    ))} />}
                        </Col>
                    </Row>
                </Col>
            </Row>
        );

    }
}

export default BOTManagementLists;
